const Constants = {
    ACCESS_TOKEN: 'Access_Token',
    ACCOUNT_ID: 'ACCOUNT_ID',
    ANALY_CUST_STATE: 'ANALY_CUST_STATE',
    X_DEVICE_REGISTERED: 'X-DEVICE-REGISTERED',
    ANALY_GUEST: 'guest',
    ANALY_LOGIN: 'logged-in',
    ANALY_LOGIN_RECOG: 'logged-in|recognized',
    ANALY_RECOG_GUEST: 'recognized|guest',
    ANALY_RECOG_LOGIN: 'recognized|logged-in',
    DEFAULT_STORE: 'defaultStore',
    DP_BARCODE_ONBOARDING_COMPLETED: 'DP_BARCODE_ONBOARDING_COMPLETED',
    DP_CHECKOUT_SAVED_ITEMS: 'DP_CHECKOUT_SAVED_ITEMS',
    DP_CHECKOUT_SAVED_ITEMS_PAYLOAD: 'DP_CHECKOUT_SAVED_ITEMS_PAYLOAD',
    DP_FIRST_NAME: 'DP_FIRST_NAME',
    DP_REWARDS_CERTS: 'DP_REWARDS_CERTS',
    DP_REWARDS_STATUS: 'DP_REWARDS_STATUS',
    DP_SAVED_ITEMS: 'DP_SAVED_ITEMS',
    DP_SAVED_ITEMS_COUNT: 'DP_SAVED_ITEMS_COUNT',
    DP_SAVED_ITEMS_PAYLOAD: 'DP_SAVED_ITEMS_PAYLOAD',
    DP_USER_LIST: 'DP_USER_LIST',
    DP_SFL_ID: 'DP_SFL_ID',
    DP_USER_DEFAULT_STORE: 'DP_USER_DEFAULT_STORE',
    DP_USER_DEFAULT_ADDRESS_ZIP: 'DP_USER_DEFAULT_ADDRESS_ZIP',
    DP_USER_NAME: 'DP_USER_NAME',
    DP_USER_STATE: 'DP_USER_STATE',
    DP_USER_ROLE: 'DP_USER_ROLE',
    DP_USER_TOKEN: 'DP_USER_TOKEN',
    DP_HAS_JCP_CARD: 'DP_HAS_JCP_CARD',
    DP_JCP_CARD: 'DP_JCP_CARD',
    DP_KEEP_ME_LOGGED: 'DP_KEEP_ME_LOGGED',
    DP_PHONE_NUMBER: 'DP_PHONE_NUMBER',
    DP_PHONE_VERIFIED_STATUS: 'DP_PHONE_VERIFIED_STATUS',
    DP_PHONE_NUMBER_TYPE: 'DP_PHONE_NUMBER_TYPE',
    DP_FULL_ACCESS_EXPIRY: 'DP_FULL_ACCESS_EXPIRY',
    DP_CURBSIDE_CHECKIN_INFO: 'DP_CURBSIDE_CHECKIN_INFO',
    DP_CURBSIDE_PRODUCT_INFO: 'DP_CURBSIDE_PRODUCT_INFO',
    DP_EMPTY_CART_LOGGING: 'DP_EMPTY_CART_LOGGING',
    DP_VISITOR_ID: 'DP_VISITOR_ID',
    DP_USER_PROFILE_TYPE: 'omni_profileType',
    DP_REWARDS_TIER: 'DP_REWARDS_TIER',
    GUEST_USER: 'GUEST_USER',
    ITEM_COUNT: 'ItemCount',
    REFRESH_TOKEN: 'Refresh_Token',
    TOKEN_API_STATUS: 'TOKEN_API_STATUS',
    USER_STORE: 'userStore',
    USER_STORE_INFO: 'userStoreInfo',
    DPCPT_COOKIES: {
        CP1Y: 'promise=v2',
        CP1N: 'promise=v1',
        CP2Y: 'v2ItemReservation',
        CP2N: 'v1ItemReservation',
    },
    CROSS_SELL: 'crossSellItemInfo',
};

export const geoErrorType = {
    GEO_LOCATE_ERROR: 'geoLocateError',
    GEO_UNAVAILABLE: 'geoUnavailable',
    EMPTY_ZIP_CODE: 'emptyZipCode',
    NOT_SUPPORTED: 'browserNotSupported',
    TIMED_OUT: 'timeout',
    AKAMAI_LOCATE_ERROR: 'AkamaiLocateError',
};

export const cookie = {
    LATLONG: '_userLoc',
    PRICE_ZONE: 'UPZ',
    previewDate: 'DP_PREVIEW_DATE',
};

export const THRESOLD_SAVEDITEMS = 50;

export const LAZY_DEFAULT_TIMEOUT = 60 * 1000; // eslint-disable-line

export default Constants;
